import { render, staticRenderFns } from "./Dictionaries.vue?vue&type=template&id=3119d43f&scoped=true&"
import script from "./Dictionaries.vue?vue&type=script&lang=js&"
export * from "./Dictionaries.vue?vue&type=script&lang=js&"
import style0 from "./Dictionaries.vue?vue&type=style&index=0&id=3119d43f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119d43f",
  null
  
)

export default component.exports